export default __webpack_public_path__ + "438081d7156018658fae5a98f1125978.png";